
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft, Mail } from "lucide-react";
import { useEffect } from "react";
import NavigationBar from "@/components/landing/NavigationBar";
import Footer from "@/components/landing/Footer";

const FAQ = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Check if we need to scroll to a specific section
    if (location.state && location.state.scrollToId) {
      const element = document.getElementById(location.state.scrollToId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // Otherwise scroll to top
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <NavigationBar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 text-white hover:bg-white/10"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
        
        <h1 className="text-3xl font-bold mb-8 text-white">Frequently Asked Questions</h1>
        
        <div className="space-y-6">
          <div className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-2 text-white">What is AnalystX?</h2>
            <p className="text-gray-300">
              AnalystX is an AI-powered market research assistant that helps you gather and analyze market intelligence quickly and efficiently.
            </p>
          </div>

          <div className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-2 text-white">How accurate is the market data?</h2>
            <p className="text-gray-300">
              Our AI uses multiple reliable sources and cross-references information to ensure accuracy. However, we recommend verifying critical data points from official sources.
            </p>
          </div>

          <div className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-2 text-white">Can I export my research?</h2>
            <p className="text-gray-300">
              Yes, you can export your research reports as PDF files. Each report includes citations and sources.
            </p>
          </div>

          <div className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-2 text-white">What industries do you cover?</h2>
            <p className="text-gray-300">
              We cover a wide range of industries including technology, healthcare, finance, retail, manufacturing, and more. Our AI is constantly updated with the latest market information.
            </p>
          </div>
          
          <div className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-2 text-white">How does the pricing work?</h2>
            <p className="text-gray-300">
              We offer various pricing plans starting from a free tier with one complimentary report to premium plans for enterprises. Visit our <a href="/#pricing" className="text-blue-400 hover:underline">pricing page</a> for more details.
            </p>
          </div>

          <div className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-2 text-white">How do I contact support?</h2>
            <div className="text-gray-300">
              <p>You can reach our support team at:</p>
              <div className="flex items-center mt-2 text-blue-400">
                <Mail className="h-5 w-5 mr-2" />
                <a href="mailto:support@analystx.co" className="hover:underline">
                  support@analystx.co
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default FAQ;
